export default {
  en: {
    'components.filing-files.proof-of-payment': 'Proof of payment',
    'components.filing-files.filing': 'Filing',
    'components.filing-files.working-files': 'Working files',
    'components.filing-files.attachments': 'Attachments',
  },
};
